import * as React from 'react';

function TxtIcon(props) {
  return (
    <svg width="40" height="40" viewBox="0 0 32.588 40.484" {...props}>
      <g
        fill="#edf2f7"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M20.242.5H4.448A3.948 3.948 0 00.5 4.448v31.588a3.948
        3.948 0 003.948 3.948h23.691a3.948 3.948 0 003.948-3.948V12.345z" />
        <path d="M20.242 1.526v11.845h11.845M24.191 23.242H8.397M24.191 31.139H8.397M12.345 15.346H8.397" />
      </g>
    </svg>
  );
}

export default TxtIcon;
